'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
const LazyLoad = require('react-lazy-load').default;
const {trackGridProductClick, trackGridProductImpressions } = require('../../actions/pdpTrackingActions.es');
const screenSize = require('../../../global/core/commonjs/screenSize');

const QuickViewButton = require('../../../components/ProductQuickView/QuickViewButton');
const QuickView = require('../../../components/ProductQuickView/QuickView');

const CarouselItem = require('./../Carousel/CarouselItem');

class GridItem extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            itemLoaded: false,
            imageHeightChanged: false
        };

        this._handleClick = this._handleClick.bind(this);
        this._showInfo = this._showInfo.bind(this);
        this._hideInfo = this._hideInfo.bind(this);
        this._imageVisible = this._imageVisible.bind(this);
    }

    _handleClick() {
        if (this.context.executeAction) {
            this.context.executeAction(trackGridProductClick, {
                product: this.props,
                gridType: this.props.gridType
            });
        }
        if (this.props.onProductClick) {
            this.props.onProductClick(this.props); //using this.props as the full product since fields were destructured
        }
    }

    _handleImpression() {
        if (this.context.executeAction) {
            this.context.executeAction(trackGridProductImpressions, {
                product: this.props,
                gridType: this.props.gridType
            });
        }
    }

    _showInfo() {
        this.props.setQuickViewId(this.props.id);
    }

    _hideInfo() {
        this.props.setQuickViewId(null);
    }

    _renderQuickView(isQuickViewOpen) {
        const {attributes, creators, description, location, materials, seller, title, uri} = this.props;
        let sellerName;
        if (typeof seller === 'string') {
            sellerName = seller;
        } else if (seller && seller.company) {
            sellerName = seller.company;
        }
        let quickView = (
            <QuickView
                {...this.props}
                onClose={this._hideInfo}
                isActive={isQuickViewOpen}
                attributes={attributes}
                creators={creators}
                description={description}
                location={location}
                materials={materials}
                seller={sellerName}
                title={title}
                uri={uri}
            />
        );
        let quickViewButton = (
            <div className="pdp-grid-quick-view-button">
                <QuickViewButton onClick={this._showInfo} />
            </div>
        );

        if (!this.props.quickView) {
            quickView = null;
            quickViewButton = null;
        } else if (isQuickViewOpen) {
            quickViewButton = null;
        }

        return (
            <div>
                {quickViewButton}
                {quickView}
            </div>
        );
    }

    _setHeight() {
        // LazyLoad height when it has no content
        let size = 240;

        if (screenSize.isMobile()) {
            size = 133;
        } else if (screenSize.isTablet()) {
            size = 189;
        }

        return size;
    }

    _setHeightState() {
        this.setState({imageHeightChanged: true});
    }

    _imageVisible() {
        this._handleImpression();
        this.setState({itemLoaded: true});
        setTimeout(this._setHeightState.bind(this), 300);
    }

    _squareImage(image) {
        const size = this._setHeight();
        return `${image}?width=${size}&height=${size}&canvas=${size},${size}`;
    }

    render() {
        const {uri, title, index, image, quickView} = this.props;
        const {itemLoaded, imageHeightChanged} = this.state;
        const isQuickViewOpen = this.props.id === this.props.quickViewItemId;
        const imageHeight = imageHeightChanged ? 'auto' : this._setHeight();

        const itemLinkClassName = classNames('pdp-grid-item-link', {
            'is-blur': isQuickViewOpen
        });
        const imageWrapperClass = classNames('pdp-grid-item-image-wrapper', {
            'is-loading': !itemLoaded
        });

        return (
            <div className="pdp-grid-item-content">
                <a href={uri} className={itemLinkClassName} onClick={this._handleClick}>
                    <div className={imageWrapperClass}>
                        <LazyLoad className="pdp-grid-lazy" height={imageHeight} onContentVisible={this._imageVisible}>
                            <CarouselItem className="pdp-grid-item-image"
                                title={title}
                                src={this._squareImage(image)}
                                index={index}
                            />
                        </LazyLoad>
                    </div>
                    <span className="pdp-grid-item-text">{title}</span>
                </a>
                {quickView ? this._renderQuickView(isQuickViewOpen) : null}
            </div>
        );
    }
}

GridItem.propTypes = {
    id: PropTypes.string.isRequired,
    uri: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
    quickView: PropTypes.bool,
    onProductClick: PropTypes.func,
    setQuickViewId: PropTypes.func,
    quickViewItemId: PropTypes.string,
    gridType: PropTypes.string,
    location: PropTypes.string,
    creators: PropTypes.string,
    attributes: PropTypes.oneOfType(
        [PropTypes.string, PropTypes.object]
    ),
    seller: PropTypes.oneOfType(
        [PropTypes.string, PropTypes.object]
    ),
    materials: PropTypes.string,
    description: PropTypes.string
};

GridItem.defaultProps = {
    gridType: 'pdp more from dealer'
};

GridItem.contextTypes = {
    getStore: PropTypes.func,
    executeAction: PropTypes.func
};

module.exports = GridItem;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Grid/GridItem.jsx